import {ImageDto} from '../apis/api-strapi/dtos/image-dto';

export const lazyLoad = (image: ImageDto): string => {
  return image.attributes.formats?.small?.url ?? image.attributes.url;
};
